<script>
import GoogleMap from '@/components/googleMap'
import mapDropPin from '../assets/map_icon/map_drop_pin.png'
export default {
  data () {
    return {
      // 地图中心点
      mapId: 'mapChoice',
      centerPoint: {
        lat: null,
        lng: null
      },
      title: '自宅を選択',
      viewModel: {
        address: '',
        stationLat: '',
        stationLng: '',
        postCode: ''
      },
      searchAddress: '',
      vehiclePoint: {}
    }
  },
  props: {
  },
  methods: {
    changeState: function (index) {
      let state = !this.cards[index].state
      this.cards[index].state = state
      this.$set(this.cards, index, this.cards[index])
    },
    goback () {
      this.$router.go(-1)
    },
    mapLeftClickEventFunc (eventObj) {
      if (eventObj.lat !== 0) {
        var self = this
        self.viewModel.stationLat = (eventObj.lat).toFixed(6)
        self.viewModel.stationLng = (eventObj.lng).toFixed(6)

        self.viewModel.address = eventObj.address
        if (Object.is(eventObj.address, undefined) || eventObj.address === '') {
          this.viewModel.address = this.vehiclePoint.name
        }

        self.viewModel.postCode = eventObj.postCode
      }
    },
    searchPlaceEvnet () {
      var _this = this
      _this.$refs.gMap.seachAndLocatePlaceProcess(_this.searchAddress).then(function (latLng) {
        var latLngOjb = {lat: latLng.lat(), lng: latLng.lng()}
        // 设置图标样式
        let vehiclePoint = {
          lat: latLngOjb.lat,
          lng: latLngOjb.lng,
          icon: mapDropPin
        }
        // 设置图标大小
        let imgSize = {width: 20, height: 54}
        _this.$refs.gMap.searchAddressInfoProcess(latLngOjb, vehiclePoint, imgSize)
      })
    },
    confirmAddress () {
      this.$emit('getAddress', this.viewModel)
    },
    initAddressChoice (vehiclePoint, imgSize) {
      this.vehiclePoint = vehiclePoint
      let pointLatLng = new global.google.maps.LatLng(vehiclePoint.lat, vehiclePoint.lng)
      if (vehiclePoint.lat !== 0 || vehiclePoint.lng !== 0) {
        this.$refs.gMap.map.setCenter(pointLatLng)
      } else {
        this.viewModel.address = ''
        this.viewModel.stationLat = ''
        this.viewModel.stationLng = ''
        // this.viewModel.postCode = ''
        this.$refs.gMap.map.setCenter(this.centerPoint)
      }
      this.$refs.gMap.searchAddressInfoProcess(null, vehiclePoint, imgSize)
    //   this.$refs.gMap.addDoubleClickEvent(vehiclePoint, imgSize)
    }
  },
  mounted () {
    // this.$refs.gMap.centerPoint = this.centerPoint
    // this.$refs.gMap.initializeGoogleMap().then(() => {
    //   this.$refs.gMap.map.setZoom(12)
    // })
    let personPoint = {
      icon: mapDropPin
    }
    let imgSize = {width: 20, height: 54}
    // this.$refs.gMap.centerPoint = this.centerPoint
    this.$refs.gMap.initializeGoogleMap().then(() => {
      this.$refs.gMap.addDoubleClickEvent(personPoint, imgSize)
    })
  },
  components: { GoogleMap }
}
</script>

<template>
    <div class="col-md-12 column">
        <div class="modal fade" id="modal-container-addressChoice" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"/></button>
                        <p class="modal-title" id="myModalLabel">
                            {{title}}
                        </p>
                    </div>
                    <div class="modal-body">
                        <div class="row clearfix">
                            <div class="col-md-6 column">
                               <div class="row clearfix">
                                 <div class="col-md-4 column clearfix divTitle shortStyle bgc8">
                                  所在地
                                </div>
                                <div class="col-md-8 column clearfix divTitle longStyle bgc5">
                                 {{viewModel.address}}
                                </div>
                               </div>
                               <div class="row clearfix divMarginTop">
                                 <div class="col-md-4 column clearfix divTitle shortStyle bgc8">
                                  緯度
                                </div>
                                <div class="col-md-8 column clearfix divTitle longStyle bgc5">
                                 {{viewModel.stationLat}}
                                </div>
                               </div>
                               <div class="row clearfix divMarginTop">
                                 <div class="col-md-4 column clearfix divTitle shortStyle bgc8">
                                  経度
                                </div>
                                <div class="col-md-8 column clearfix divTitle longStyle bgc5">
                                 {{viewModel.stationLng}}
                                </div>
                               </div>
                            </div>
                            <div class="col-md-6 column">
                                <div class="row clearfix inputdiv" style="margin-bottom: 10px">
                                <input type="text" title="検索" placeholder="検索" v-model="searchAddress" @blur="searchPlaceEvnet"  @keydown.enter="searchPlaceEvnet"/>
                                </div>
                                <div class="row clearfix" style="width:105%">
                                    <GoogleMap ref="gMap"
                                        :center-point="centerPoint"
                                        :map-id="mapId"
                                        @mapLeftClickEvent = "mapLeftClickEventFunc">
                                    </GoogleMap>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="row clearfix">
                                <div class="col-md-6 column" style="text-align: right">
                                    <button class="window-button" data-dismiss="modal" @click="confirmAddress">決定</button>
                                </div>
                                <div class="col-md-6 column" style="text-align: left">
                                    <button class="window-button" data-dismiss="modal">キャンセル</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .modal-dialog{
        width: 80%;
        margin-top: 1.6%;
    }
    .modal-header{
        border-bottom: 0px;
    }
    .modal-title{
        font-size: 26px;
    }
    .modal-body{
        padding-left:3%;
        padding-right: 3%;
        margin-bottom: 0px;
    }
    .window-button{
        width: 70%;
        height: 50px;
        border-radius: 10px;
        margin-top: 30px;
        margin-bottom: 20px;
        font-size: 2em;
        color: #fff;
        background-color: #717171;
    }
    .close{
        opacity: 1;
    }
    .inputdiv {
        float: left;
        border: solid 2px #ccc;
        border-radius: 10px;
        width: 105%;
        height: 50px;
        background: url(../assets/select.png) no-repeat 10px center;
     }
    .inputdiv input {
       float: left;
       border: none;
       background: none;
       outline: none;
       height: 50px;
       line-height: 50px;
       width: 100%;
       /* 可以对应调整.text中的backgroud和下面的text-indent调整图标和input输入地方的间距 */
       text-indent: 50px;
    }
    .divTitle {
      background: #cecece;
      height: 50px;
      line-height: 50px;
      font-size: 15px;
      color: black;
    }
    .shortStyle{
      width: 25%
    }
    .longStyle{
      width: 70%;
      margin-left: 2%;
      text-align: left
    }
    .divMarginTop{
     margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AddressChoice.vue